module.exports = __webpack_public_path__ + "static/img/1.32326e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruselFuturo/1.jpg
// module id = zLUt
// module chunks = 5